import { useSelector } from 'react-redux'

import { getActiveStepType } from '@/ducks/shopProgressReducer'
import { SHOP_STEPS } from '@/util/shop'

import StepAccessories from './StepAccessories'
import StepConfirm from './StepConfirm'
import StepContract from './StepContract'
import StepCreditCheck from './StepCreditCheck'
import StepCustomer from './StepCustomer'
import StepFrameAgreement from './StepFrameAgreement'
import StepMainProduct from './StepMainProduct'
import StepPaymentOptions from './StepPaymentOptions'
import StepPlaceholder from './StepPlaceholder'
// @ts-ignore
const stepTypeToComponent = stepType => {
  switch (stepType) {
    case SHOP_STEPS.PAYMENT:
      return StepPaymentOptions
    case SHOP_STEPS.CUSTOMER:
      return StepCustomer
    case SHOP_STEPS.MAIN_PRODUCT:
      return StepMainProduct
    case SHOP_STEPS.ACCESSORIES:
      return StepAccessories
    case SHOP_STEPS.CREDIT_CHECK:
      return StepCreditCheck
    case SHOP_STEPS.FRAME_AGREEMENT:
      return StepFrameAgreement
    case SHOP_STEPS.CONTRACT:
      return StepContract
    case SHOP_STEPS.CONFIRM:
      return StepConfirm
    default:
      return StepPlaceholder
  }
}

const Step = () => {
  const stepType = useSelector(getActiveStepType)
  const Component = stepTypeToComponent(stepType)

  return (
    <div>
      <Component />
    </div>
  )
}

export default Step
